import React from 'react'

const YamanIslim = () =>
  <div className="page bio">
    Yaman Islim
  </div>

export default YamanIslim
